import { createApp } from "vue";
import FormBuilder from "./components/FormBuilder.vue";

import("bootstrap");

export default createApp(FormBuilder).mount("#app");
